import { core, formatDecimal, round2, type Decimal } from '@map-my-money/engine';

/** Money on the wire: a decimal string rounded half away from zero to 2 dp (contract §1.2). */
export const money = (value: Decimal): string => formatDecimal(round2(value));

/** Percent change of `to` against `from`, 1 dp; null when `from` is 0. */
export function percentChange(from: Decimal, to: Decimal): number | null {
  const base = core.toDouble(from);
  if (base === 0) return null;
  return Math.round(((core.toDouble(to) - base) / Math.abs(base)) * 1000) / 10;
}

export const round1 = (n: number): number => Math.round(n * 10) / 10;

export const num = (value: Decimal): number => core.toDouble(value);

/** Whose words and currency a plan's text uses. The plan document carries no currency: a US plan is in dollars, any other in pounds. */
export type Region = 'uk' | 'us';

export const regionOf = (plan: { readonly configuration?: { readonly taxJurisdiction?: string | undefined } | undefined } | null | undefined): Region =>
  plan?.configuration?.taxJurisdiction === 'us' ? 'us' : 'uk';
